import * as graphql from 'generated/graphql';

import { useFeatureDetails } from '../packages/kakapo-ui-application/hooks/useFeature';

import EvaluationSubmission from './evaluation-submission/EvaluationSubmission';
import ConversationHOC from './conversation/ConversationHOC';
import { Spinner } from '@treams/treams-ui';
import { Flex } from '@mantine/core';
import { useHistory } from 'react-router';

export default function Conversation({
	userID,
	conversationID,
}: {
	userID?: string;
	conversationID: string;
}) {
	const { available, loading } = useFeatureDetails(graphql.FeatureName.Q3_2024Conversations);

	const history = useHistory();

	const returnUrl = (() => {
		const params = new URLSearchParams(history.location.search);
		if (params.has('return') && params.get('return')?.startsWith('/')) {
			return params.get('return');
		}

		if (userID) {
			return `/users/${userID}/conversations`;
		}
		return '/conversations';
	})()!;

	if (loading) {
		return (
			<Flex align="center" justify="center" p="60px">
				<Spinner size="18px" />
			</Flex>
		);
	}

	return available ? (
		<ConversationHOC returnUrl={returnUrl} conversationID={conversationID} />
	) : (
		<EvaluationSubmission returnUrl={returnUrl} evaluationSubmissionID={conversationID} />
	);
}
